import { RestrictionCategoryId } from '@/models/restriction/category/id';
import { RestrictionDetailsModalRestrictionsDetailsCardsProps } from '../props';
import styles from './styles.module.scss';
import { FormGroup } from '@starsoft/common/components';
import useTranslation from 'next-translate/useTranslation';
import { useMemo } from 'react';

export default function RestrictionDetailsModalRestrictionsDetailsCategory({
  restriction,
}: RestrictionDetailsModalRestrictionsDetailsCardsProps) {
  const { t } = useTranslation('common');
  const icon = useMemo(() => {
    switch (restriction?.categoryId?.toString()) {
      case RestrictionCategoryId.Deposit?.toString():
        return 'fa-solid fa-piggy-bank';
      case RestrictionCategoryId.Withdrawal?.toString():
        return 'fa-solid fa-wallet';
      case RestrictionCategoryId.Spend?.toString():
        return 'fa-solid fa-hand-holding-dollar';
      case RestrictionCategoryId.Stake?.toString():
        return 'fa-solid fa-coins';
      default:
        return 'fa-solid fa-hourglass-start';
    }
  }, [restriction?.categoryId]);

  return (
    <FormGroup label={t('restriction_details_category_label')}>
      <div className={styles.container}>
        <i className={`${styles.container__icon} ${icon}`} />
        <p className={styles.container__label}>
          {t(`account:${restriction?.categoryId}_category_label`)}
        </p>
      </div>
    </FormGroup>
  );
}
